/**
 * Slate Design tokens
 * Reference: https:www.figma.com/file/jQPqQpDxUlUrVD9oS897Ti/Slate-Typography?type=design&node-id=0-1&mode=design&t=it0bQ5CFTIkA8n0K-0
 */
export var TextStyleType;
(function (TextStyleType) {
    TextStyleType["TEXT_STYLE_TYPE_UNKNOWN"] = "TEXT_STYLE_TYPE_UNKNOWN";
    TextStyleType["LABEL"] = "LABEL";
    TextStyleType["PARAGRAPH"] = "PARAGRAPH";
    TextStyleType["SUBHEADING"] = "SUBHEADING";
    TextStyleType["SECTION_HEADER"] = "SECTION_HEADER";
    TextStyleType["PAGE_HEADER"] = "PAGE_HEADER";
    TextStyleType["DISPLAY_S_SANS"] = "DISPLAY_S_SANS";
    TextStyleType["DISPLAY_S_SERIF"] = "DISPLAY_S_SERIF";
    TextStyleType["DISPLAY_M"] = "DISPLAY_M";
    TextStyleType["DISPLAY_L"] = "DISPLAY_L";
    TextStyleType["DISPLAY_XL"] = "DISPLAY_XL";
})(TextStyleType || (TextStyleType = {}));
